var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLongrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 63,
    viewBox: "0 0 49 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8125 15.5312H19.9375M10.8125 31.5H38.1875M10.8125 40.625H38.1875M10.8125 49.75H19.9375M6.25 61.1562H42.75C43.9601 61.1562 45.1205 60.6756 45.9762 59.8199C46.8318 58.9643 47.3125 57.8038 47.3125 56.5938V6.40625C47.3125 5.1962 46.8318 4.03571 45.9762 3.18008C45.1205 2.32444 43.9601 1.84375 42.75 1.84375H6.25C5.03995 1.84375 3.87946 2.32444 3.02383 3.18008C2.16819 4.03571 1.6875 5.1962 1.6875 6.40625V56.5938C1.6875 57.8038 2.16819 58.9643 3.02383 59.8199C3.87946 60.6756 5.03995 61.1562 6.25 61.1562Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1875 16.6719C38.8174 16.6719 39.3281 16.1612 39.3281 15.5312C39.3281 14.9013 38.8174 14.3906 38.1875 14.3906C37.5576 14.3906 37.0469 14.9013 37.0469 15.5312C37.0469 16.1612 37.5576 16.6719 38.1875 16.6719Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLongrid);
export default __webpack_public_path__ + "static/media/longrid.b3378cfe35418b74b92e8f71f131a8dc.svg";
export { ForwardRef as ReactComponent };